import { render, staticRenderFns } from "./policyManage.vue?vue&type=template&id=9d42043e&scoped=true&"
import script from "./policyManage.vue?vue&type=script&lang=js&"
export * from "./policyManage.vue?vue&type=script&lang=js&"
import style0 from "./policyManage.vue?vue&type=style&index=0&id=9d42043e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d42043e",
  null
  
)

export default component.exports